var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sector-edit__wrapper" },
    [
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("server") },
      }),
      _vm._v(" "),
      _c("ValidationAlert", {
        attrs: { "error-list": _vm.errors.collect("event") },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form",
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "modal",
            {
              attrs: {
                name: "warning",
                height: "auto",
                adaptive: true,
                width: 450,
              },
            },
            [
              _c("div", { staticClass: "modal__title" }, [
                _c("span", { staticClass: "h2" }, [
                  _vm._v(_vm._s(_vm.modal.title)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__copy" }, [
                _c("p", [_vm._v(_vm._s(_vm.modal.copy))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.hide },
                  },
                  [
                    _vm._v(
                      "\n                    I understand\n                "
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("fieldset", { staticClass: "form__group" }, [
            _c(
              "div",
              { staticClass: "sector-edit__new" },
              [
                _c("div", { staticClass: "form__group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.name,
                        expression: "formData.name",
                      },
                    ],
                    class: {
                      form__control: true,
                      "form__control--invalid": _vm.errors.first("name"),
                    },
                    attrs: {
                      id: "name",
                      name: "name",
                      placeholder: "Enter a title",
                      required: "",
                    },
                    domProps: { value: _vm.formData.name },
                    on: {
                      input: [
                        function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.formData, "name", $event.target.value)
                        },
                        function ($event) {
                          return _vm.slugify_field(_vm.formData.name)
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "form__label", attrs: { for: "name" } },
                    [_vm._v("Name")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__validation" }, [
                    _vm._v(_vm._s(_vm.errors.first("name"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("FormControlMember", {
                  attrs: {
                    label: "Select a Company",
                    placeholder:
                      "Select the company that the user works for...",
                    name: "member",
                  },
                  model: {
                    value: _vm.formData.member,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "member", $$v)
                    },
                    expression: "formData.member",
                  },
                }),
                _vm._v(" "),
                _c("FileUpload", {
                  ref: "document",
                  attrs: {
                    id: "document",
                    label: "Drag and drop document here (.xlsx only)",
                    name: "document",
                    "file-types":
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    multiple: false,
                  },
                  model: {
                    value: _vm.formData.document,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "document", $$v)
                    },
                    expression: "formData.document",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "form__group form__group--submit" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--primary",
                      attrs: { disabled: !_vm.formValid },
                    },
                    [_vm._v("Save & Continue")]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }